<ui-page-container>
  <mat-card>
    <mat-card-title>{{ 'Gestione basi' | translate }}</mat-card-title>
    <mat-card-content>
      <ui-table
        [filters]="filters$ | async"
        [rowSelection]="'checkbox'"
        [fields]="fields"
        [pager]="pager$"
        [reload]="reload$"
        [itemsPage]="page$ | async"
        [contextMenuActions]="contextMenus"
        (itemsPageChange)="applyChangePageHandler($event)"
        (select)="selectHandler($event)"
        (rowAction)="manageRowActions($event)">
        <div tableActions>
          <app-entity-actions
            className="Base"
            [config]="{ showExport: false }"
            [selectedItemsCount]="selectedItems?.length || 0"
            (add)="addHandler()"
            (delete)="deleteSelectedHandler()"
            (collectionAdd)="addToCollectionHandler()">
          </app-entity-actions>
        </div>
        <div tableFilters>
          <ui-filters
            [dialogFilters]="MobileFiltersComponent"
            (action)="applyFilterWithDelayHandler($event)">
            <app-base-filters
              [filters]="filtersObj$ | async"
              #desktopFilter>
            </app-base-filters>
          </ui-filters>
        </div>
      </ui-table>
    </mat-card-content>
  </mat-card>
</ui-page-container>
